import React from 'react'

function CartIcon({ large }) {
  return (
    large ? renderLargeCartIcon() : renderRegularCartIcon()
  )
}

export const renderRegularCartIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/Shopping Cart" clipPath="url(#clip0_3566_700)">
        <path id="Vector" d="M6.25 18.75C6.94036 18.75 7.5 18.1904 7.5 17.5C7.5 16.8096 6.94036 16.25 6.25 16.25C5.55964 16.25 5 16.8096 5 17.5C5 18.1904 5.55964 18.75 6.25 18.75Z" fill="#F4F4F4"/>
        <path id="Vector_2" d="M15 18.75C15.6904 18.75 16.25 18.1904 16.25 17.5C16.25 16.8096 15.6904 16.25 15 16.25C14.3096 16.25 13.75 16.8096 13.75 17.5C13.75 18.1904 14.3096 18.75 15 18.75Z" fill="#F4F4F4"/>
        <path id="Vector_3" d="M17.5 4.37513H3.6375L3.125 1.75013C3.09578 1.60683 3.01724 1.47832 2.90304 1.38696C2.78884 1.2956 2.64622 1.24718 2.5 1.25013H0V2.50013H1.9875L4.375 14.5001C4.40422 14.6434 4.48276 14.7719 4.59696 14.8633C4.71116 14.9547 4.85378 15.0031 5 15.0001H16.25V13.7501H5.5125L5 11.2501H16.25C16.3945 11.2537 16.5357 11.207 16.6497 11.1181C16.7636 11.0292 16.8432 10.9036 16.875 10.7626L18.125 5.13763C18.1459 5.04489 18.1455 4.9486 18.1236 4.85608C18.1017 4.76357 18.059 4.67726 17.9987 4.60373C17.9385 4.53021 17.8622 4.4714 17.7758 4.43178C17.6894 4.39217 17.595 4.37279 17.5 4.37513ZM15.75 10.0001H4.7625L3.8875 5.62513H16.7188L15.75 10.0001Z" fill="#F4F4F4"/>
      </g>
      <defs>
        <clipPath id="clip0_3566_700">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export const renderLargeCartIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/Shopping Cart" clipPath="url(#clip0_3561_5992)">
        <path id="Vector" d="M8 22.5C8.82843 22.5 9.5 21.8284 9.5 21C9.5 20.1716 8.82843 19.5 8 19.5C7.17157 19.5 6.5 20.1716 6.5 21C6.5 21.8284 7.17157 22.5 8 22.5Z" fill="#F4F4F4"/>
        <path id="Vector_2" d="M18.5 22.5C19.3284 22.5 20 21.8284 20 21C20 20.1716 19.3284 19.5 18.5 19.5C17.6716 19.5 17 20.1716 17 21C17 21.8284 17.6716 22.5 18.5 22.5Z" fill="#F4F4F4"/>
        <path id="Vector_3" d="M21.5 5.25015H4.865L4.25 2.10015C4.21494 1.9282 4.12068 1.77398 3.98364 1.66435C3.8466 1.55472 3.67546 1.49661 3.5 1.50015H0.5V3.00015H2.885L5.75 17.4002C5.78506 17.5721 5.87932 17.7263 6.01636 17.836C6.1534 17.9456 6.32454 18.0037 6.5 18.0002H20V16.5002H7.115L6.5 13.5002H20C20.1734 13.5044 20.3429 13.4484 20.4796 13.3418C20.6163 13.2351 20.7119 13.0843 20.75 12.9152L22.25 6.16515C22.2751 6.05387 22.2745 5.93832 22.2483 5.8273C22.222 5.71628 22.1708 5.61271 22.0985 5.52448C22.0261 5.43625 21.9347 5.36568 21.8309 5.31814C21.7272 5.2706 21.614 5.24735 21.5 5.25015ZM19.4 12.0002H6.215L5.165 6.75015H20.5625L19.4 12.0002Z" fill="#F4F4F4"/>
      </g>
      <defs>
        <clipPath id="clip0_3561_5992">
          <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default CartIcon
